import { ICheckboxStyleProps, ICheckboxStyles, IStyleFunctionOrObject, mergeStyles } from "@fluentui/react";

export const listContainerStyles = mergeStyles([{
    width: '100%',
    gap: '1dvh'
}]);

export const rowContainerStyles = mergeStyles([{
    width: '100%',
    height: '1rem',
    margin: '1.5dvh'
}]);

export const mdRowContainerStyles = mergeStyles([{
    width: '100%',
    height: '7dvh'
}]);

export const smRowContainerStyles = mergeStyles([{
    width: '100%',
    height: '6dvh'
}]);

export const trialTitleContainerStyles = mergeStyles([{
    width: '100%',
    marginTop: '2dvh',
    marginBottom: '2dvh',
}]);

export const registerEvaluationRowContainerStyles = mergeStyles([{
    width: '100%',
    padding: '1dvh',
    backgroundColor: '#F0F0F0',
    cursor: 'pointer',
    borderRadius: '5px'
}]);

export const registerEvaluationRowContainerSelectedStyles = mergeStyles([{
    width: '100%',
    backgroundColor: '#F0F0F0',
    cursor: 'pointer',
    borderRadius: '5px',
    border: '2px solid #a9c963'
}]);

export const registerEvaluationRowInnerContainerSelectedStyles = mergeStyles([{
    width: 'inherit',
    padding: '1dvh',
    backgroundColor: 'rgba(169, 201, 99, 0.2)'
}]);

export const registerEvaluationRowTextContainerStyles = mergeStyles([{
    gap: '0.5dvh',
}]);

export const registerEvaluationRowCheckboxStyles: IStyleFunctionOrObject<ICheckboxStyleProps, ICheckboxStyles> = {
    root: {
        borderRadius: '50%'
    },
    checkbox: {
        borderRadius: '50%'
    }
}

//#region ROW TITLE

export const titleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: '1.2rem',
    fontWeight: 600,
    color: '#2A7DE1',

    textAlign: 'left'
}]);

export const xxlTitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(0.95rem, 2.5vw, 1rem)',
    fontWeight: 600,
    color: '#2A7DE1',

    textAlign: 'left'
}]);

export const xlTitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(0.9rem, 2.5vw, 0.95rem)',
    fontWeight: 600,
    color: '#2A7DE1',

    textAlign: 'left'
}]);

export const lgTitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(0.85rem, 2.5vw, 0.9rem)',
    fontWeight: 600,
    color: '#2A7DE1',

    textAlign: 'left'
}]);

export const mdTitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(0.8rem, 2.5vw, 0.85rem)',
    fontWeight: 600,
    color: '#2A7DE1',

    textAlign: 'left'
}]);

export const smTitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(0.75rem, 2.5vw, 0.8rem)',
    fontWeight: 600,
    color: '#2A7DE1',

    textAlign: 'left'
}]);

//#endregion ROW TITLE

//#region ROW DESCRIPTION

export const descriptionStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: '1rem',
    fontWeight: 300,
    color: '#323130',

    textAlign: 'left'
}]);

export const xxlDescriptionStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(0.85rem, 2.5vw, 0.9rem)',
    fontWeight: 300,
    color: '#323130',

    textAlign: 'left'
}]);

export const xlDescriptionStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(0.8rem, 2.5vw, 0.85rem)',
    fontWeight: 300,
    color: '#323130',

    textAlign: 'left'
}]);

export const lgDescriptionStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(0.75rem, 2.5vw, 0.8rem)',
    fontWeight: 300,
    color: '#323130',

    textAlign: 'left'
}]);

export const mdDescriptionStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(0.7rem, 2.5vw, 0.75rem)',
    fontWeight: 300,
    color: '#323130',

    textAlign: 'left'
}]);

export const smDescriptionStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(0.65rem, 2.5vw, 0.7rem)',
    fontWeight: 300,
    color: '#323130',

    textAlign: 'left'
}]);

//#endregion ROW DESCRIPTION

//#region ROW INNER TITLE

export const innerRowTitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: '1.2rem',
    fontWeight: 400,
    color: '#2A7DE1',

    textAlign: 'left'
}]);

export const xxlInnerRowTitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(0.75rem, 2.1vw, 0.85rem)',
    fontWeight: 400,
    color: '#2A7DE1',
    textAlign: 'left'
}]);

export const xlInnerRowTitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(0.8rem, 2.5vw, 0.9rem)',
    fontWeight: 400,
    color: '#2A7DE1',
    textAlign: 'left'
}]);

export const lgInnerRowTitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(0.75rem, 2.5vw, 0.85rem)',
    fontWeight: 400,
    color: '#2A7DE1',
    textAlign: 'left'
}]);

export const mdInnerRowTitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(0.7rem, 2.5vw, 0.8rem)',
    fontWeight: 400,
    color: '#2A7DE1',
    textAlign: 'left'
}]);

export const smInnerRowTitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(0.65rem, 2.5vw, 0.75rem)',
    fontWeight: 400,
    color: '#2A7DE1',
    textAlign: 'left'
}]);


//#endregion ROW INNER TITLE

//#region ROW INNER DESCRIPTION

export const innerRowDescriptionStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: '1rem',
    fontWeight: 300,
    color: '#323130',

    textAlign: 'left'
}]);

export const xxlInnerRowDescriptionStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(0.8rem, 2.5vw, 0.85rem)',
    fontWeight: 300,
    color: '#323130',

    textAlign: 'left'
}]);

export const xlInnerRowDescriptionStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(0.75rem, 2.5vw, 0.8rem)',
    fontWeight: 300,
    color: '#323130',

    textAlign: 'left'
}]);

export const lgInnerRowDescriptionStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(0.7rem, 2.5vw, 0.75rem)',
    fontWeight: 300,
    color: '#323130',

    textAlign: 'left'
}]);

export const mdInnerRowDescriptionStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(0.65rem, 2.5vw, 0.7rem)',
    fontWeight: 300,
    color: '#323130',

    textAlign: 'left'
}]);

export const smInnerRowDescriptionStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(0.6rem, 2.5vw, 0.65rem)',
    fontWeight: 300,
    color: '#323130',

    textAlign: 'left'
}]);

//#endregion ROW INNER DESCRIPTION